<script setup lang="ts">
import type {EventSimple} from '~/types/event'

const MAX_SHOW = 4
const props = defineProps<{
  events: EventSimple[],
  title: string
}>()

const showMoreEvents = computed(() => props.events?.length > MAX_SHOW)
</script>

<template>
  <section class="container event-carroucel">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="h3 mb-0">{{ title }}</h2>
      <nuxt-link v-if="showMoreEvents" class="btn btn-link fw-normal p-0" to="/eventos">
        Ver mais<i class="fi-arrow-long-right ms-2"></i>
      </nuxt-link>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3" v-for="(event, id) in events" :key="id">
        <EventCard :event="event"/>
      </div>
    </div>
  </section>
</template>
